import { logger } from "../helpers/tslog";

export const errorMessages = {
    "chart-extraction": "We encountered an error while processing your chart. If the problem persists, contact support for assistance.",
    "refresh-chart": "We couldn't refresh this chart. Please try again or reconnect the workbook.",
    "chart-not-correctly-refresh": "Chart not correctly refreshed. Please try again.",
    // User action guidance errors (updated copy)
    "chart-not-selected": "No chart/table image selected. Please select the AlphaScript chart/table image that you want to refresh.",
    "workbook-not-open": "I see you selected a chart/table to Refresh but the underlying Excel is not open. Please select Open Excel for the chart/table first. Then make desired changes to the chart/table before selecting the Refresh button.",
    // First-click informational guidance (one-time per user)
    "refresh-info": "info setup inthe error app component",
    "excel-file-url-not-found": "You selected a chart/table it not have attached an excel file to open. please selected the correct chart/table and try again.",
};

export enum ErrorMessageType {
    CLOSE = "CLOSE",
}

export function openErrorWindow(error: string) {
    const frontendUrl = process.env.REACT_APP_PUBLIC_URL;
    const url = `${frontendUrl}/error.html?error=${error}`;
    Office.context.ui.displayDialogAsync(url, { height: 30, width: 30, displayInIframe: true }, async (result) => {
        logger.info(result);
        if (result.status === Office.AsyncResultStatus.Failed) {
            logger.error("Failed to open dialog:", result.error.message);
        } else {
            const dialog = result.value;
            dialog.addEventHandler(Office.EventType.DialogMessageReceived, async (arg: any) => {
                switch (arg.message) {
                    case ErrorMessageType.CLOSE:
                        dialog.close();
                        break;
                    default:
                        break;
                }
            }
            );
        }
    });
}

